(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tp-hero-carousel')) {
  class TpHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.tp-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.tp-hero__dot'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.touchX = null;

      this.addEventListener('click', (event) => {
        const nav = event.target.closest('[data-dir]');
        const dot = event.target.closest('[data-index]');
        if (nav) this.go(Number(nav.dataset.dir));
        if (dot) this.show(Number(dot.dataset.index));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(-1);
        if (event.key === 'ArrowRight') this.go(1);
      });
      this.addEventListener('touchstart', (event) => {
        this.touchX = event.changedTouches[0].clientX;
        this.stop();
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchX == null) return;
        const delta = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(delta) > 42) this.go(delta < 0 ? 1 : -1);
        this.touchX = null;
        this.start();
      }, { passive: true });

      this.show(this.index);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      if (this.reduce || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.go(1), 5000);
    }

    stop() {
      window.clearInterval(this.timer);
    }

    go(direction) {
      this.show((this.index + direction + this.slides.length) % this.slides.length);
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('tp-hero-carousel', TpHeroCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
